import React from 'react';
import templeimg from '../assets/temple2.png';
import CalendarMobile from '../Components/CalendarMobile';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInstagram,
  faTwitter,
  faYoutube,
  faFacebook,
} from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

const EventPage = () => {
  const events = [
    {
      name: 'Pt. Ramdas Bhajan Event',
      timing: '8am to 11 am',
    },
    {
      name: 'Pt. Ramdas Bhajan Event',
      timing: '8am to 11 am',
    },
    {
      name: 'Pt. Ramdas Bhajan Event',
      timing: '8am to 11 am',
    },
  ];

  return (
    <div
      className=" min-h-screen w-full bg-cover bg-center"
      style={{
        backgroundImage: `url(${templeimg})`,
      }}
    >
      <div className="min-h-screen  inset-0 bg-[#430F07]  w-full bg-cover bg-center bg-opacity-55">
        <div className="w-full px-[20px] md:px-[10%] flex flex-col md:flex-row items-start gap-10 justify-center pt-10 text-white">
          <div className="md:w-1/3">
            <p className="font-abhaya text-[36px] text-left">Calendar</p>
            <div className="ml-[20px] md:mx-0">
              <CalendarMobile />
            </div>
          </div>

          <div className="w-full md:w-2/3">
            <p className="font-abhaya text-[36px] text-left">Upcoming Events</p>
            <div className="flex flex-col gap-3 w-full">
              {events.map((event) => {
                return (
                  <div className="flex flex-row items-center justify-between bg-[#6A1B09] bg-opacity-75 rounded-[10px] px-2 py-3 shadow-lg hover:shadow-xl backdrop-blur-md">
                    <div>
                      <p className="font-afacad text-[20px] text-left text-[#FED0AA] m-0 p-0">
                        {event.name}
                      </p>
                      <p className="font-afacad text-[12px] text-left text-[#FB823C] m-0 p-0">
                        Timings : {event.timing}
                      </p>
                    </div>
                    <div className="bg-[#7C2412] w-12 h-12 rounded-full flex items-center justify-center shadow-md hover:shadow-lg transition-shadow">
                      <span className="text-[#E66526] text-lg font-bold">
                        &#x276F;
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="hidden md:flex text-white px-[10%] py-10 w-full h-full items-center justify-center mt-10">
          <div className="flex flex-col md:flex-row items-center gap-8 w-full">
            {/* Left Section - Aarti Timings */}
            <div className="w-full md:w-[30%] bg-[#641E0E] bg-opacity-90 py-10 px-10 mx-10 rounded-lg shadow-lg text-left">
              <h3 className="text-[40px] font-abhaya font-bold mb-4 text-center">
                Aarti Timings
              </h3>
              <ul className="list-disc space-y-3 text-[20px] font-afacad">
                <li>Kakad Aarti: 5:30–6:00 AM</li>
                <li>Evening Aarti: 7:30–8:00 PM</li>
                <li>Shejaarti: 9:50 PM</li>
              </ul>
            </div>

            <div className="w-full md:w-[70%] text-center flex flex-col items-center gap-6">
              {/* Title */}
              <div className="flex flex-col items-center justify-center">
                <h3 className="text-[50px] font-jaini mb-2">|| जय हनुमान ||</h3>
                <h3 className="text-[80px] font-jaini mb-4">
                  || जय श्री राम ||
                </h3>
              </div>

              {/* Social Media Icons */}
              <div className="flex justify-center gap-6 text-[30px]">
                <a
                  href="https://www.instagram.com/hanuman_temple_jerseycity?igsh=aW5rN2lmazhvOGkz"
                  className="hover:text-orange-300 transition"
                  aria-label="Instagram"
                >
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
                <a
                  href="link"
                  className="hover:text-orange-300 transition"
                  aria-label="Twitter"
                >
                  <FontAwesomeIcon icon={faFacebook} />
                </a>
                <a
                  href="link"
                  className="hover:text-orange-300 transition"
                  aria-label="Email"
                >
                  <FontAwesomeIcon icon={faEnvelope} />
                </a>
                <a
                  href="link"
                  className="hover:text-orange-300 transition"
                  aria-label="YouTube"
                >
                  <FontAwesomeIcon icon={faYoutube} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventPage;
